import { useNavigate } from 'react-router-dom'
import { AppLabel, AppLink, AppSpan, AppText, Button, Circle, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, GridContainer } from "src/style"
import utility from "src/utils/utility"
import {ReactComponent as Logo} from 'src/assets/img/crendly-logo-blue.svg'
import { IoChevronBackOutline } from 'react-icons/io5'
import { MdOutlineMarkEmailUnread } from 'react-icons/md'
import helpers from 'src/utils/helpers'
import { useContext, useEffect, useState } from 'react'
import ApiContext from 'src/provider/API/call-service';
import UserContext from 'src/provider/state-manager/userProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'


const ForgotPasswordOtp: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {user: {userInfo}} = useContext(UserContext)
    const {setInfoProperty} = useContext(AppInfoContext)
    const [otp, setOtp] = useState('')
    var [time, setTime] = useState<any>(null)
    var [count, setCount] = useState<any>(0)

    useEffect(() => {
        if (count === 30) API.initiatePasswordReset(userInfo.email)
    }, [count])

    useEffect(() => {
        return () => { clearInterval(time) }
    }, [])

    const handleCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length < 7) {
            setOtp(e.target.value)
        }
    }

    function handleResendCounter () {
        time =  setInterval(async () => {
            setCount((count: number) => {
                if (count === 30) {
                    clearInterval(time)
                    return 0
                }
                else return count + 1
            });
        }, 1000)
    }

    async function handleNext (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        await setInfoProperty('passwordResetOtp', otp)
        navigate('/forgetpassword/password-reset')
    }

    return (
        <FlexColumn 
            height='100' hUnit='%' width='100' 
            sizeUnit='%' justifyContent='space-between'
            bottomPadding='1.5' leftPadding='1' rightPadding='1'
        >
            <GridContainer 
                width='90' sizeUnit='%' height='7'
                className="forgetpassword-header"
            >
                <FlexRow 
                    justifyContent="space-between"
                >
                    <Logo />
                    <AppLink decoration="none" color='#101225' textSize="1.2">User type selected here</AppLink>
                </FlexRow>
            </GridContainer>
            <FlexRow alignItems='flex-start' width='auto' sizeUnit=''>
                <GridContainer 
                    height='3' width='3.2' borderColor=' #E4ECF7' 
                    radius='0.4' rightMargin='4'
                    onClick={() => navigate(-1)}
                >
                    <IoChevronBackOutline className='back-icon' />
                </GridContainer>
                <CustomContainer 
                    width='52' minHeight='60' bgColor='#ffffff'
                    borderColor='#E2E8F0' radius='0.8' topPadding='3'
                    bottomPadding='3' rightPadding='4.5' leftPadding='4.5'
                >
                    {/* <Circle 
                        size='6.7' bottomMargin='3.5'
                        bgColor='#E1E8FF' className='identity-lock'
                    >
                        <MdOutlineMarkEmailUnread 
                            style={{fontSize: '3.2rem', color: '#3754DB'}} 
                        />
                    </Circle>
                    <AppText color='#27272E' textSize='2.8' fontWeight='600' align='center' bottomMargin='1'>Check you email</AppText>
                    <AppText color=' #27272E' textSize='1.6' align='center' >
                        We sent a password reset link to 
                        <AppSpan color=' #27272E' textSize='1.6' fontWeight='600'> amadichijindu@email.com </AppSpan>
                    </AppText>
                    <Form topMargin='5'>
                        <Button
                            width='100' sizeUnit='%' borderColor='#4C6FFF' height='4.5'
                            hoverBgColor='#ffffff' hoverColor='#4C6FFF' bottomMargin='1.5'
                            onClick={() => navigate('/forgetpassword/password-reset')}
                        >
                            Open your email
                        </Button>

                       <GridContainer bottomMargin='2'>
                            <Button
                                width='14' height='4' bgColor='#FAFAFA'
                                hoverColor='#4C6FFF' radius='0.6' color='#425466'
                                onClick={() => navigate('/')}
                            >
                                <IoChevronBackOutline style={{marginLeft: '1rem'}} /> 
                                Back to login
                            </Button>
                       </GridContainer>
                    </Form> */}
                    <Circle 
                        size='6.7' bottomMargin='3.5'
                        bgColor='#E1E8FF' className='identity-lock'
                    >
                        <MdOutlineMarkEmailUnread 
                            style={{fontSize: '3.2rem', color: '#3754DB'}} 
                        />
                    </Circle>
                    <AppText textSize='2.8' fontWeight='600' color='#27272E' align='center'>Password Reset OTP</AppText>
                    <AppText textSize='1.6' color='#27272E' align='center' topMargin='1'>
                        Please provide the OTP sent to your email for password reset
                    </AppText>
                    <Form topMargin='7' onSubmit={handleNext}>
                        <FormGroup bottomMargin='1.5'>
                            <AppLabel>Enter OTP code</AppLabel>
                            <FlexRow width="auto" sizeUnit="">
                                <input 
                                    className='display-hidden' id='code' 
                                    name="otp" value={otp} 
                                    onChange={handleCode} 
                                    autoFocus={true} autoComplete="off"
                                />
                                <label className="code-verification" htmlFor='code' >{otp[0] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[1] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[2] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[3] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[4] || ''}</label>
                                <label className="code-verification" htmlFor='code' >{otp[5] || ''}</label>
                            </FlexRow>
                        </FormGroup>
                        <AppText color='#718096' textSize='1.2'>
                            OTP will resend in <AppSpan fontWeight='600' color='#16192C' textSize='1.2'>{helpers.formatSeconds(30-count)} sec</AppSpan>
                        </AppText>
                        <AppText color='#718096' textSize='1.2' topMargin='3'>
                            Didn’t get OTP? 
                            <AppSpan 
                                fontWeight='600' color='#4C6FFF' textSize='1.2' 
                                hoverColor='#718096' cursor='pointer' leftPadding='0.4'
                                onClick={() => count === 0 ? handleResendCounter() : null}
                            > 
                                Resend 
                            </AppSpan>
                        </AppText>
                        <Button
                            width='100' sizeUnit='%' borderColor='#4C6FFF' height='4.5'
                            hoverBgColor='#ffffff' hoverColor='#4C6FFF' bottomMargin='2.5'
                            topMargin='5'
                        >
                            Continue
                        </Button>
                        <GridContainer bottomMargin='2'>
                            <Button
                                width='14' height='4' bgColor='#FAFAFA'
                                hoverColor='#4C6FFF' radius='0.6' color='#425466'
                                onClick={() => navigate('/')}
                            >
                                <IoChevronBackOutline style={{marginLeft: '1rem'}} /> 
                                Back to login
                            </Button>
                       </GridContainer>
                    </Form>
                </CustomContainer>
            </FlexRow>
            <GridContainer 
                width='90' sizeUnit='%' height='5'
                className="forgetpassword-footer"
            >
                <FlexRow 
                    justifyContent="space-between"
                >
                    <AppLink 
                        decoration='none' textSize='1.2'
                    >
                        Crendly support panel 2022
                    </AppLink>
                </FlexRow>
            </GridContainer>
        </FlexColumn>
    )
}

export default utility.routeData('forgetpassword/password-reset-otp', 'Reset Password Otp', <ForgotPasswordOtp/>)